import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import { baseActions } from "../../base/models/BaseSlice";
import useQuery from "../../base/utils/UseQuery";
import ADPProjectsTable from "../components/ADPProjectsTable";

const ADProjects = () => {
  const dispatch = useDispatch();
  const contentDivHeight = useSelector(
    (state: any) => state.base.contentDivHeight,
  );
  const headerHeight = 0;
  const rowPadding = 12;
  const paperHeight = contentDivHeight - 2.5 * rowPadding - headerHeight - 5;

  React.useEffect(() => {
    dispatch(baseActions.setPaperHeight(paperHeight));
  }, [dispatch, paperHeight]);

  const query = useQuery();
  const province = query.get("province");
  const [showGrid, setShowGrid] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <React.Fragment>
      {/*<div style={{ padding: "15px" }}>*/}
      {showGrid && <ADPProjectsTable province={province || ""} />}
      {/*</div>*/}
    </React.Fragment>
  );
};

export default ADProjects;
